import React, { useState, useEffect } from 'react';
import './HomeHero.css';
import gradientBorderImg from '../../assets/images/gradient-border.svg';
import Separator from '../Separator';
import Button from '../Button';

export const HomeHero = () => {
  const [heroData, setHeroData] = useState(null);
  useEffect(() => {
    async function fetchPost() {
      try {
        const result = await fetch(
          "https://ai4.io/wp-json/wp/v2/posts?slug=ai-2024-home",
          {
            method: "GET",
            headers: {
              'Content-Type': 'application/json',
            },
          }
        );
        setHeroData((await result.json())?.[0]?.content?.rendered);
      } catch(e) {
        console.log('error: ', e);
      }
      
    }
    fetchPost();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <div className="home-hero">
    <div
      dangerouslySetInnerHTML={{__html: heroData}}
    />
    <div className="register-button-wrapper">
      <img src={gradientBorderImg} alt="Gradient background" id="hero-gradient" />
      <div className="register-button-inner-wrapper">
        <Separator className="separator" />
        <div className="horizontal-separator" />
        <h3 className="register-date">August 12-14<br/>mgm grand, las vegas</h3>
        <Button label="Register now" />
      </div>
    </div>
    <h3 className="vertical-text">MGM GRAND<br/>LAS VEGAS</h3>
    <h2 className="horizontal-date">AUGUST<br/><span>2024</span></h2>
  </div>;
};
